import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LoaderService } from './../services/loader.service';

@Injectable({
  providedIn: 'root',
})
export class LoaderInterceptor {
  constructor(private loaderService: LoaderService) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const shouldOpenLoader = !request.url.includes('calculate');
    if (shouldOpenLoader) {
      this.loaderService.open();
    }
    return next.handle(request).pipe(
      finalize(() => {
        if (shouldOpenLoader) {
          this.loaderService.close();
        }
      }),
      catchError((err) => {
        if (shouldOpenLoader) {
          this.loaderService.close();
        }
        return throwError(err);
      }),
    );
  }
}
